import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useContactLensProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../types/product.js';
import { isNonRecoverableError } from '../../../../types/typeguards.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../slots/context.js';
import '@grandvisionhq/content';
import { useCLEcommContext } from '../context/CLEcommContext.js';
import { useGetCLByPrescription } from './api/use-get-cl-by-prescription.js';
import { mapClientToServerPrescription } from './api/mappers/client-to-server/map-client-to-server-prescription.js';

const useFetchCLByPrescription = ({ eyeSide  })=>{
    const { actions , maxOrderableQuantity , triggerToastMessage  } = useCLEcommContext();
    const { activeVariant: { masterVariantSku , sku: activeSku  } ,  } = useContactLensProductData();
    const onSuccess = React.useCallback((result)=>{
        const { prescriptionCLProduct  } = result;
        actions.updateQueryResult({
            eyeSide,
            maxOrderableQuantity,
            prescriptionCLProduct
        });
    }, []);
    const onError = React.useCallback((result)=>{
        actions.updateQueryResult({
            eyeSide,
            maxOrderableQuantity,
            error: result.error
        });
        if (isNonRecoverableError(result.error)) {
            triggerToastMessage('non-recoverable-rx-error');
        }
    }, []);
    const getCLByPrescription = useGetCLByPrescription({
        onSuccess,
        onError
    });
    const fetchCLByPrescription = React.useCallback((columnConfigurations)=>{
        const prescription = mapClientToServerPrescription(columnConfigurations);
        if (prescription) {
            actions.setQueryLoading({
                eyeSide,
                loading: true
            });
            getCLByPrescription({
                masterVariantSku,
                prescription
            }, activeSku);
        }
    }, [
        actions,
        activeSku,
        masterVariantSku,
        eyeSide,
        getCLByPrescription
    ]);
    return fetchCLByPrescription;
};

export { useFetchCLByPrescription };
//# sourceMappingURL=use-fetch-cl-by-prescription.js.map
